<mat-form-field class="bold-required-field">
  <mat-label> {{ fieldLabel }}</mat-label>
  <ng-container *ngVar="compartmentList | filterCompartmentsByType : activityType as compartments">
    <ng-container *ngIf="!!filterControl; else wholeCompartmentSelect">
      <!-- Compartment address select from the whole compartment -->
      <mat-select [formControl]="fieldControl" [attr.test-id]="testId" [disabledControl]="disabled">
        <mat-select-trigger *ngIf="fieldControl.value as compartment">
          <span class="compartment-name-strong">
            {{ compartments | findFilteredCompartmentName : compartment }}
          </span>
          {{ compartment?.fullAddress }}
        </mat-select-trigger>
        <mat-option
          *ngFor="
            let compartmentAddress of compartments
              | transformCompartmentToAddress
              | filterSimilarAddress : filterControl.value
          "
          [value]="compartmentAddress"
          [matTooltip]="
            (compartments | findFilteredCompartmentName : compartmentAddress) + ' | ' + compartmentAddress.fullAddress
          "
        >
          <span class="compartment-name-strong">
            {{ compartments | findFilteredCompartmentName : compartmentAddress }}
          </span>
          | {{ compartmentAddress.fullAddress }}
        </mat-option>
      </mat-select>
    </ng-container>
    <!-- Whole compartment select -->
    <ng-template #wholeCompartmentSelect>
      <mat-select [formControl]="fieldControl" [attr.test-id]="testId" [disabledControl]="disabled">
        <mat-select-trigger *ngIf="fieldControl.value?.compartmentAddresses[0] as firstAddress">
          <span class="compartment-name-strong">
            {{ compartments | findFilteredCompartmentName : firstAddress }}
          </span>
          {{ firstAddress?.fullAddress }}
        </mat-select-trigger>
        <mat-option
          *ngFor="let compartmentAddress of compartments | transformCompartmentToAddress; let index = index"
          [value]="compartments[index]"
          matTooltipPosition="after"
          [matTooltip]="
            (compartments | findFilteredCompartmentName : compartmentAddress) + ' | ' + compartmentAddress.fullAddress
          "
        >
          <span class="compartment-name-strong">
            {{ compartments | findFilteredCompartmentName : compartmentAddress }}
          </span>
          | {{ compartmentAddress.fullAddress }}
        </mat-option>
      </mat-select>
    </ng-template>
  </ng-container>

  <mat-error>
    <ng-content></ng-content>
  </mat-error>
</mat-form-field>
